export type PresenceStatus = 1 | 2; // 1: active, 2: out

export interface FriendPresence {
  userId: string;
  state: PresenceStatus;
}

export function isFriendOnline(status: PresenceStatus | undefined): boolean {
  switch (status) {
    case 1: // active
    case 2: // out
      return true;
    default:
      // offline
      return false;
  }
}
